module.exports = __webpack_public_path__ + "static/3-1382c9105ce54e5c9c52ab6086428a17.jpg";